module.exports = __webpack_public_path__ + "static/img/helene.30ebc99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/helene.jpg
// module id = TuXM
// module chunks = 1